import dayjs from 'dayjs';

export const currentTimeGreaterThanExpiry = (startingEventDateTime: string) => {
	const expiryPeriod = dayjs(+startingEventDateTime).add(1, 'hour');
	const currentTimeGreaterThanExpiry = dayjs().isAfter(expiryPeriod);
	return currentTimeGreaterThanExpiry;
};
